import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import classnames from 'classnames';

import styles from './FooterCopyright.module.css';

const messages = defineMessages({
  footerCopyright: {
    id: 'src.components.FooterCopyright.footerCopyright',
    defaultMessage: '© Copyright {year} Cadeaubon.nl',
  },
});

export type Props = {
  className?: string;
};

export const FooterCopyright = React.memo((props: Props) => {
  const { className } = props;

  const classNames = classnames(
    styles.footerCopyright,
    className,
  );

  const year = React.useMemo(() => new Date().getFullYear(), []);

  return (
    <p className={classNames}>
      <FormattedMessage {...messages.footerCopyright} values={{ year }} />
    </p>
  );
});

FooterCopyright.displayName = 'FooterCopyright';
